/* eslint-disable */
import DepartureCityEntity from '../Entity/DepartureCity';

const DepartureCityFactory = function(data) {
	var departureCity = new DepartureCityEntity(),
		element;

	element = data['id'];
	if(typeof element != "undefined") {
		departureCity.set('id', element);
	}
	
	element = data['name'];
	if(typeof element != "undefined") {
		departureCity.set('name', element);
	}

	element = data['type'];
	if(typeof element != "undefined") {
		departureCity.set('type', element);
	}

	element = data['countries'];
	if(typeof element != "undefined") {
		departureCity.set('countries', element);
	}

	departureCity.set('daysRange', 1);
	return departureCity;
};

export default DepartureCityFactory;